import { useUiStateContextUiSchema } from '~/hooks/useUiStateContextUiSchema';

export function useUiStateContextFormBackButtonPressHandler() {
  const uiContext = useUiStateContextUiSchema();

  return uiContext?.backButtonPressHandler;
}
